<template>
    <span>
        <a v-if="isusername" href="#" @click="showpop">{{info.username}}</a>
        <a v-else href="#" @click="showpop" :title="$common.basic.strunformat(info.showname||info.username)">{{$common.basic.strgetlen(info.showname||info.username,10)}}</a>

        <el-dialog v-if="isshowpop" :visible.sync="isshowpop" top="0px" class="mydialogprofile modulewrap" append-to-body>
            <fflearnerdetail :memid="info.id" :isteacher="isteacher" @aftersave="aftersave()"></fflearnerdetail>

        </el-dialog>
    </span>

</template>


<script>
    export default {
        name: 'fflearner',
        data() {
            return {
                isshowpop: false
            }
        },
        props: {
            info: {
                type: Object,
                default: () => { }
            },
            isusername: {
                type: Boolean,
                default: false
            },
            isteacher: {
                type: Boolean,
                default: false
            }
        },
        methods: {
            showpop: function () {
                this.isshowpop = true;
            },
            aftersave: function () {
                this.$emit('aftersave');
            }
        }
    }
</script>
